var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.background
      ? 'card-header pt-4 pb-4 custom-header-bg'
      : 'card-header pt-4 pb-4'},[_c('div',{staticClass:"row align-items-center"},[_c('Actions',{attrs:{"items":_vm.actions}}),(_vm.breadCrumb && _vm.breadCrumb.length)?_c('BreadCrumb',{attrs:{"bread-crumb":_vm.breadCrumb}}):(_vm.title && _vm.title.length)?_c('Title',{attrs:{"title":_vm.title}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }